var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"stroke":"#B6BCCA","stroke-width":"2","d":"M10 1h5v5h-5zM10 10h5v5h-5zM1 1h5v5H1zM1 10h5v5H1z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }